
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportDailyPIGrid extends Serenity.EntityGrid<ReportDailyPIRow, any> {
        protected getColumnsKey() { return ReportDailyPIColumns.columnsKey; }
        protected getDialogType() { return ReportDailyPIDialog; }
        protected getIdProperty() { return ReportDailyPIRow.idProperty; }
        protected getInsertPermission() { return ReportDailyPIRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportDailyPIRow.localTextPrefix; }
        protected getService() { return ReportDailyPIService.baseUrl; }

        public mn: string;
        public year: string;
        public shop:string;
        public sup:string;

        constructor(container: JQuery) {
            super(container);
            let qryrow = Q.tryFirst(QRreport.QRywcSpecRow.getLookup().items,x => x.Id == 124)

            this.mn = qryrow.DateBegin;
            this.year = qryrow.DateEnd;
            this.shop = qryrow.ShopId;
            this.sup = qryrow.SupplId;
        }

        

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportDailyPIService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
        
            buttons.push(
                {
                    title: Q.text("รายการเอกสาร"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o',
                    onClick: () => {
                        //var row = this.view.getRows();                        
                    const request = this.getView().params as ReportDailyPIData  //ReportDailyPIDetailData

                    request.para = Q.tryFirst(Administration.CsParaRow.getLookup().items, x=> x.Id == 1).BizName
                    request.DatetoDate = "วันที่เอกสาร :" + this.mn + " to " + this.year

                    if(this.shop != null){
                        let x = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.shop )
                        request.Shop = "ผู้จำหน่าย : " + this.shop + " - " + x.ShopName
                    }else{
                        request.Shop = "ผู้จำหน่าย : ทั้งหมด" 
                    }

                    if(this.sup != null){
                        let x = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x => x.SupplId == this.sup )
                        request.Supdata = this.sup + " - " + x.SupplName
                    }else{
                        request.Supdata = ""
                    }
                    
                    request.ListHd = this.view.getRows();                    

                    Q.postToService({ service: this.getService() + '/ExportPdf1', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber
                        
                    },
               
                }
            ); 

            buttons.push(
                {
                    title: Q.text("แสดงรายละเอียด"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o',
                    onClick: () => {
                        //var row = this.view.getRows();                        
                    const request = this.getView().params as ReportDailyPIDetailData  //ReportDailyPIDetailData
                    

                    request.para = Q.tryFirst(Administration.CsParaRow.getLookup().items, x=> x.Id == 1).BizName
                    request.DatetoDate = "วันที่เอกสาร :" + this.mn + " to " + this.year

                    if(this.shop != null){
                        let x = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.shop )
                        request.Shop = this.shop + " : " + x.ShopName
                    }else{
                        request.Shop = ""
                    }

                    if(this.sup != null){
                        let x = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x => x.SupplId == this.sup )
                        request.Supdata = this.sup + " : " + x.SupplName
                    }else{
                        request.Supdata = "ผู้จำหน่าย : ทั้งหมด" 
                    }
                    
                    request.ListHd = this.view.getRows();   
                                                 
                    

                    Q.postToService({ service: this.getService() + '/ExportPdf2', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber
                        
                    },
               
                }
            ); 
           
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecReportpoDaily/edit/124';
                        return false;
                    },
                }
            );       


            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();          

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            
            this.view.setSummaryOptions({
                aggregators: [
                    
                    
                    new Slick.Aggregators.Sum('TotalAmt'),
                    new Slick.Aggregators.Sum('DiscAmt'),
                    new Slick.Aggregators.Sum('NetAmt'),
                    new Slick.Aggregators.Sum('VatAmt'),
                    new Slick.Aggregators.Sum('ExciseTaxAmt'),
                    new Slick.Aggregators.Sum('CreditNoteAmt'),
                    new Slick.Aggregators.Sum('DepositAmt')
                   
                ]

                

            });     
            return grid;
        }

        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }
    }
}